module.exports = __webpack_public_path__ + "assets/946e58a9dbb9ca4af54d90564aa5bf91.mp3";